import { gql } from 'graphql-request'

export namespace AccessInstructionQueries {
  export const ACCESS_INSTRUCTIONS_DETAILS = gql`
    fragment AccessInstructionDetails on AccessInstruction {
      name
      instruction
      userType
      accessType
      id
      accessibleType
      accessibleId
    }
  `
}
